import { useEffect, useState } from 'react';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';

export const useConfetti = ():
readonly [JSX.Element, ((value: (((prevState: boolean) => boolean) | boolean)) => void)] => {

  const { width, height } = useWindowSize();

  const [ confetti, setConfetti ] = useState(<></>);
  const [ isRunning, setRunning ] = useState(false);

  useEffect(() => {
    setConfetti(
      <Confetti
        width={width}
        height={height}
        style={{ pointerEvents: 'none' }}
        numberOfPieces={isRunning ? 500 : 0}
        recycle={false}
        onConfettiComplete={(confetti) => {
          setRunning(false);
          confetti?.reset();
        }}
      />,
    );
  }, [ isRunning ]);

  return [ confetti, setRunning ] as const;
};
